/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import useApi from '../../../../utils/api-manager/Helper/useApi';
import { LineChart } from '../../../common/ReusableComponent/Chart';

function MonthlyProfitChart() {
  const [monthlyProfitData, setMonthlyProfitData] = useState([]);
  const [months, setMonths] = useState([]);
  const { Post } = useApi();

  const getMonthName = (monthString) => {
    const date = new Date(monthString);
    return date.toLocaleString('en-US', { month: 'long' });
  };

  const generateAllMonthsArray = (year) => {
    return Array.from({ length: 12 }, (_, i) => `${year}-${String(i + 1).padStart(2, '0')}`);
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();

    const fetchMonthlyProfit = async () => {
      try {
        const response = await Post('monthlyProfit', {
          start_date: `${currentYear}-01-01`,
          end_date: `${currentYear}-12-31`,
        });

        const apiData = response.data;
        const monthsArray = generateAllMonthsArray(currentYear);
        const profitArray = monthsArray.map((month) => {
          const data = apiData.find((item) => item.month === month);
          return data ? data.total_profit : 0;
        });

        setMonths(monthsArray.map(getMonthName));
        setMonthlyProfitData(profitArray);
      } catch (error) {
        console.error('Error fetching monthly profit data', error);
      }
    };

    fetchMonthlyProfit();
  }, []);

  const isDataEmpty = monthlyProfitData.length === 0 || monthlyProfitData.every((val) => !val || val === 0);

  return (
    <div style={{
      marginBottom: '20px',
      ...(isDataEmpty && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px', // match chart height or adjust as needed
      })
    }}>
      {isDataEmpty ? (
        <p style={{
          fontSize: '16px',
          color: '#999',
          textAlign: 'center',
          fontStyle: 'italic',
        }}>
          No profit data available for this year.
        </p>
      ) : (
        <LineChart
          labels={months}
          datasets={[
            {
              label: 'Monthly Profit',
              data: monthlyProfitData,
            },
          ]}
          title={`Monthly Profit for ${new Date().getFullYear()}`}
          theme="custom"
          height="300px"
          width="600px"
          noShadow
          noBorder
        />
      )}
    </div>
  );
  
}

export default MonthlyProfitChart;
